import RichText from '@/components/RichText/RichText';
import useMediaQuery from '@/hooks/useMediaQuery';
import beTwMerge from '@/utils/beTwMerge';
import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';

type TableProps = {
  anchorLinkID: string;
  backgroundColor: string;
  columnWidth: string;
  fontWeight: string;
  headings: { heading: string }[];
  headerAlign: string;
  headerVerticalAlign: string;
  margin: boolean;
  mobileColumnWidth: string;
  rows: {
    data: {
      isLongestText: boolean;
      text: string;
    }[];
  }[];
  rowsAlign: string;
  rowsVerticalAlign: string;
};
export default function Table({
  anchorLinkID,
  backgroundColor,
  columnWidth,
  fontWeight,
  headerAlign,
  headerVerticalAlign,
  headings,
  margin,
  mobileColumnWidth,
  rows,
  rowsAlign,
  rowsVerticalAlign,
}: TableProps) {
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  let fontClass = '[&_*]:!tw-font-book';
  if (fontWeight === '500') {
    fontClass = '[&_*]:!tw-font-avenirmedium';
  }
  if (fontWeight === '800') {
    fontClass = '[&_*]:!tw-font-heavy';
  }

  const mobileTableWidth = mobileColumnWidth ? `${headings.length * Number(mobileColumnWidth)}px` : '100%';
  const tableWidth = columnWidth ? `${headings.length * Number(columnWidth)}px` : '100%';
  return (
    <div className={beTwMerge('tw-px-4 large:tw-px-0', getComponentMargin(margin))} {...getAnchorId(anchorLinkID)}>
      <table
        className={`tw-border tw-border-[#D9D9D9] tw-border-solid tw-border-collapse ${mobileColumnWidth ? 'tw-table-fixed' : 'tw-table-auto'} ${columnWidth ? 'large:tw-table-fixed' : 'large:tw-table-auto'}`}
        style={{ width: isDesktop ? tableWidth : mobileTableWidth }}
      >
        <thead>
          <tr className="tw-bg-[#f9f9f9]">
            {headings?.map(heading => (
              <th
                className={`tw-p-3 tw-font-avenirmedium tw-text-[14px] tw-border tw-border-[#D9D9D9] tw-border-solid ${headerAlign === 'center' ? 'tw-text-center' : ''} ${headerVerticalAlign === 'top' ? 'tw-align-text-top' : ''}`}
              >
                {heading.heading}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows?.map(row => (
            <tr
              className={`${rowsAlign === 'center' ? 'tw-text-center' : ''} ${rowsVerticalAlign === 'top' ? 'tw-align-text-top' : ''}`}
              style={{ backgroundColor }}
            >
              {row.data?.map(datum => (
                <td
                  className={`tw-p-3 tw-border tw-border-[#D9D9D9] tw-border-solid ${!columnWidth && datum.isLongestText ? 'large:tw-whitespace-nowrap' : ''}`}
                >
                  <RichText
                    className={`[&_ul]:tw-mb-0 [&_ul]:tw-pl-4 [&_ul>li]:!tw-text-[14px] [&_p]:!tw-text-[14px] ${fontClass}`}
                    content={datum.text}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
